module.exports = __webpack_public_path__ + "static/media/material-timer.4271813a.svg";